import React from 'react';

import {
  PaymentSecurityBoxContainer,
  PaymentSecurityItem,
  PaymentSecurityItemIconCol,
  PaymentSecurityItemContentCol,
  PaymentSecurityItemTitle,
  PaymentSecurityItemText,
  PaymentSecurityItemIcon,
  PaymentSecurityContentBox,
} from './PaymentSecurityBox.style';

import lockImg from '../../../assets/lock01.svg';
import checkImg from '../../../assets/checkVerifiedCloud.svg';

export const PaymentSecurityBox: React.FC = () => {
  return (
    <PaymentSecurityContentBox>
      <PaymentSecurityBoxContainer>
        <PaymentSecurityItem>
          <PaymentSecurityItemIconCol>
            <PaymentSecurityItemIcon src={lockImg} alt="lock" />
          </PaymentSecurityItemIconCol>
          <PaymentSecurityItemContentCol>
            <PaymentSecurityItemTitle>Secure Payment</PaymentSecurityItemTitle>
            <PaymentSecurityItemText>This is a secure 128-bit SSL encrypted payment.</PaymentSecurityItemText>
          </PaymentSecurityItemContentCol>
        </PaymentSecurityItem>

        <PaymentSecurityItem>
          <PaymentSecurityItemIconCol>
            <PaymentSecurityItemIcon src={checkImg} alt="check" />
          </PaymentSecurityItemIconCol>
          <PaymentSecurityItemContentCol>
            <PaymentSecurityItemTitle>100% Guaranteed</PaymentSecurityItemTitle>
            <PaymentSecurityItemText>14-day money back guarantee</PaymentSecurityItemText>
          </PaymentSecurityItemContentCol>
        </PaymentSecurityItem>
      </PaymentSecurityBoxContainer>
    </PaymentSecurityContentBox>
  );
};
